import PropTypes from "prop-types";
import { useState } from "react";
import { List } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

  const handleUserProfile = () => {
    navigate("/user-profile");
  };

  const menuItems = [
    {
      key: 1,
      icon: <UserOutlined style={{ minWidth: 32, color: defaultColors.text.secondary }} />,
      text: "View Profile",
      onClick: () => {
        handleListItemClick(1);
        handleUserProfile();
      }
    },
    {
      key: 2,
      icon: <LogoutOutlined style={{ minWidth: 32, color: defaultColors.text.secondary }} />,
      text: "Logout",
      onClick: (e) => {
        handleLogout(e);
        setSelectedIndex(2);
      }
    }
  ];

  return (
    <List
      dataSource={menuItems}
      renderItem={(item) => (
        <List.Item
          key={item.key}
          onClick={item.onClick}
          className={`cursor-pointer transition-colors px-0 ${selectedIndex === item.key ? 'bg-gray-50' : 'hover:bg-gray-50'}`}
          style={{ borderBottom: 'none' }}
        >
          <div className="flex items-center gap-3 w-full p-2">
            {item.icon}
            <span>{item.text}</span>
          </div>
        </List.Item>
      )}
    />
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func,
};

export default ProfileTab;
